import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { GameDetailsList, GameDetailsListProps } from './GameDetailsList';
import {
  OperatingSystemRequirementsList,
  OperatingSystemRequirementsListProps,
} from './OperatingSystemRequirementsList';
import { RequirementTabs } from './RequirementsTabs';
import { useMobile } from 'src/hooks/useMobile';

export interface GameCardSystemRequirementsProps {
  requirements: OperatingSystemRequirementsListProps[];
  gameDetails: GameDetailsListProps;
}

export function GameCardSystemRequirements({
  requirements,
  gameDetails,
}: GameCardSystemRequirementsProps) {
  const isMobile = useMobile();

  return (
    <Stack direction="row" flexWrap="wrap" gap="32px">
      {isMobile && <GameDetailsList {...gameDetails} />}
      <Stack direction="row" flexWrap="wrap" gap="32px">
        {requirements.map((operatingSystemReqs) => (
          <Box
            key={`${operatingSystemReqs.name}-requirements`}
            sx={{
              maxWidth: '709px',
              width: '100%',
              borderRadius: '4px',
              height: 'fit-content',
              backdropFilter: 'blur(4px)',
              background: (theme) => theme.palette.background.elevation[2],
              display: 'flex',
              flexWrap: 'nowrap',
              alignItems: 'flex-start',
              justifyContent: 'center',
              padding: '16px 48px 16px 48px',
              boxShadow: (theme) => theme.shadowsHard.emboss,
              ...(isMobile && { padding: '16px ' }),
            }}
          >
            <Stack flexDirection="row" flexWrap="nowrap" alignItems="flex-end">
              <Box sx={{ height: 'inherit' }}>
                <OperatingSystemRequirementsList {...operatingSystemReqs} />
              </Box>
              <Box>
                <RequirementTabs {...operatingSystemReqs.requirements} />
              </Box>
            </Stack>
          </Box>
        ))}
      </Stack>
      {!isMobile && <GameDetailsList {...gameDetails} />}
    </Stack>
  );
}
